<nb-card>
  <nb-card-header>
    <div class="overview">
      <nb-actions size="none">
        <nb-action>
          <nb-icon status="info" icon="list-outline"></nb-icon>
          <span>{{ exercise.noExUser ? exercise.noExUser : "." }}</span>
        </nb-action>

        <nb-action>
          <nb-icon status="success" icon="award-outline"></nb-icon>
          <span>
            {{ exercise.noExUserCompleted ? exercise.noExUserCompleted : "." }}
          </span>
        </nb-action>
      </nb-actions>

      <nb-actions size="none">
        <nb-action>
          <nb-icon [status]="'info'" icon="layers-outline"></nb-icon>
          <span>{{ exercise.noQuiz ? exercise.noQuiz : "0" }}</span>
        </nb-action>

        <nb-action>
          <nb-icon status="success" icon="percent-outline"></nb-icon>
          <span
            >{{
              exercise.percentCompleted > 0 ? exercise.percentCompleted : "~"
            }}
          </span>
        </nb-action>

        <nb-action>
          <nb-icon
            status="warning"
            class="action-icon"
            icon="clock-outline"
          ></nb-icon>
          <span
            >{{ exercise.duration > 0 ? exercise.duration + " p" : "~" }}
          </span>
        </nb-action>
      </nb-actions>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="content">
      <ngx-view-image
        *ngIf="exercise.coverUrl"
        [imageURL]="exercise.coverUrl"
      ></ngx-view-image>

      <div
        *ngIf="!exercise.coverUrl && exercise.description"
        class="text-hint description"
      >
        {{ exercise.description }}
      </div>
    </div>
  </nb-card-body>
</nb-card>
